export const newBlock = {
    contentType: "text",
    content: "Edit text here...",
};

export const newRow = {
    cols: [{
        blocks: [
            {
                contentType: "text",
                content: "Edit text here...",
            }
        ]
    }]
};